import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueMask from 'v-mask'
import wysiwyg from "vue-wysiwyg";

Vue.config.productionTip = false

import "vue-wysiwyg/dist/vueWysiwyg.css";

let image_upload_url = `http://localhost:5001/taste-together/us-central1/uploadImage`

// uploadedProductImage (file) {
//   let item = {
//     productId: this.productId,
//     file
//   }
//   this.$store.dispatch('AUTH.uploadProductImage', item).then((res) => {
//     this.productImageUrl = res.url
//   })
// },

Vue.use(wysiwyg, {
  maxHeight: '400px',
  image: {
    uploadURL: image_upload_url,
    dropzoneOptions: {
      autoProcessQueue: false,
      url: `http://`,
      thumbnailWidth: 150,
      maxFilesize: 1,
      dictDefaultMessage: ``
      // uploadedProductImage
    }
  },
  hideModules: { 
    code: true,
    removeFormat: true,
    table: true,
    separator: true,
    image: true,
  },
});
// This variable will hold the reference to
// document's click handler
let handleOutsideClick
Vue.directive('closable', {
  // created(){}
  bind (el, binding, vnode) {
    // console.log
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false
      if (exclude) {
        exclude.forEach(refName => {
          // We only run this code if we haven't detected
          // any excluded element yet
          if (!clickedOnExcludedEl) {
            // Get the element using the reference name
            const excludedEl = vnode.context.$refs[refName]
            // See if this excluded element
            // is the same element the user just clicked on
            clickedOnExcludedEl = excludedEl ? excludedEl.contains(e.target) : false
          }
        })
      }
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

Vue.use(VueMask);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
  },
  computed: {
  }
})



// WEBPACK FOOTER //
// ./src/main.js